/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.home-slider .splide');

if( slider ) {
    var main = new Splide( '.home-slider .splide', {
        type      : 'fade',
        rewind    : true,
        pagination: false,
        arrows    : false,
        perPage: 1,
        perMove: 1,
        gap: '1%',
        breakpoints: {
            960: {
                perPage: 1,
            },
        }
    });

    var thumbnails = new Splide( '#thumbnail-carousel', {
        gap : 15,
        perPage: 4,
        rewind : true,
        pagination: false,
        arrows : false,
        isNavigation: true,
        breakpoints : {
            768: {
                gap : 10,
            },
        },
    });

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
}